module.exports = __webpack_public_path__ + "img/kachel-HERZKREISLAUF-REISHI.ec61ad19.png";